import ListingBookNowCard from './ListingBookNowCard';

export default ListingBookNowCard;
